import React,{ Component } from 'react';
import $ from 'jquery';
import { Link,browserHistory } from 'react-router';
import {Modal,Button,OverlayTrigger,Popover,Breadcrumb} from 'react-bootstrap';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import {connect} from 'react-redux';
import * as actions from './../../actions';
const parseHtml = require('html-react-parser');
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

class Web_MyCart extends Component{
	constructor(props){
		super(props);
		this.state={}
		this.state={
			total: '',
			cartcount:'',
			grandtotal:'',
			items:[],
			aqua_cash:'',
			used_cash:'',
			used_cash1:'',
			ac_discount:'',
			coupons_amt:'',
			coupons_amt1:'',
			grand_total:'',
			openModal:false,
			applied_coupons:'',
			applied_coupons1:'',
			coupon_ref:'',
			coupon_err_msg:'',
			coupon_err_status:false,
			updateModal:false,
			coupon_success_status:false,
			coupon_success_msg:'',
			coupon_success_value:'',
			delete_status:false,
			delete_status_id:'',
			
			qty:'',
			min_qty:'',
			max_qty:'',
			cart_id:'',
			err_qty_status: false,
			err_qty_msg:'',
			emptyCartConfirm:false,
			coupons: [],
			billing_status:false,

			proceedCheck:0,
			proceedMsg:'',
			ac_enough_msg:'',
			loc_msg:'',
			add_id:0,

			coupon_code:0,
			coupon_price:0,

			state:'',
			zip:'',
			city:'',
			address:'',
			save_local_address_msg_status:false,
			ac_enough_msg_status:false,
			proceedMsg_status: false,

			promodiscount:'',
			promos:[],
			applied_promos:'',

			checkout_page_loading:false,
			pay_clicked:false,

			page_loading:false,
		}
		this.close=this.close.bind(this);
		this.submitCoupon=this.submitCoupon.bind(this);
		this.changeCoupon=this.changeCoupon.bind(this);
		this.getCart=this.getCart.bind(this);
		this.updateMinQty=this.updateMinQty.bind(this);
		this.updateMinQtyModal=this.updateMinQtyModal.bind(this);
		this.deleteSingleItem=this.deleteSingleItem.bind(this);
		this.emptyCart=this.emptyCart.bind(this);
		this.emptyCartConfirm=this.emptyCartConfirm.bind(this);
		this.delete=this.delete.bind(this);

		this.updateQuantity=this.updateQuantity.bind(this);
		this.enableBillingDetails=this.enableBillingDetails.bind(this);
		this.placeOrder=this.placeOrder.bind(this);
		this.applyCoupon_getCart=this.applyCoupon_getCart.bind(this);
		this.removeCoupon=this.removeCoupon.bind(this);
		this.saveDefaultAddress=this.saveDefaultAddress.bind(this);
		this.saveAddress_placeOrder=this.saveAddress_placeOrder.bind(this);
		this.getCartCount=this.getCartCount.bind(this);
	}

	//saveDefaultAddress function is used to save the new address in checkout page
	saveDefaultAddress()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		}
		else
		{
			uid=0;
		}
		var data1= {from:'desktop_web',id:uid,token:localStorage.getItem('token'),name:localStorage.user_name,mobile:localStorage.user_mobile,state:this.state.state,city:this.state.city,address:this.state.address,zip:this.state.zip};
	    var data2= JSON.stringify(data1);
	    $.ajax({
      		method:'POST',
      		dataType:'json',
      		url:baseUrl+'saveAdd',
      		data:{req:data2},
      		success:function(data)
      		{
      			this.setState({
      				add_id:data.add_id,
				});
      			localStorage.setItem('address_change_flag',data.address_change);
      			this.saveAddress_placeOrder();
      			if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
      		error:function(err)
      		{
      		}
  		});
	}
	getCartCount()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
        var data1={from: 'desktop_web',id:uid,token:localStorage.getItem('token')};
        var data2=JSON.stringify(data1);
        $.ajax({
              method: 'POST',
              url: baseUrl+'cart_count',
              dataType:'json',
              data: {req:data2},
              success: function(data)
              {
                this.setState({
                    cartcount:data.cart_count,
				});
				// if(data.cart_count===0)
	   //          {
	   //            	$('#cart_count').hide();
	   //          }
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
              }.bind(this),
              error: function(err)
              {
              
              }
        });
	}
	emptyCartConfirm()
	{
		this.setState({
			emptyCartConfirm:true,
		});
	}
	//function updateQuantitiy is used to update the qunatity of the product in modal box and updating the cart values by calling the "applyCoupon_getCart" 
	updateQuantity()
	{
		var x='';
		if(parseInt(this.state.qty,10) < parseInt(this.state.min_qty,10))
		{
			// alert('Minimum Quantity is '+this.state.min_qty);
			x='Minimum Quantity is '+this.state.min_qty;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Minimum Quantity is '+this.state.min_qty,
			});
		}
		if(this.state.qty==='')
		{
			// alert('Minimum Quantity is '+this.state.min_qty);
			x='Minimum Quantity is '+this.state.min_qty;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Minimum Quantity is '+this.state.min_qty,
			});
		}
		if(parseInt(this.state.qty,10) > parseInt(this.state.max_qty,10))
		{
			// alert('Maximum Quantity is '+this.state.max_qty);
			x='Maximum Quantity is '+this.state.max_qty;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Maximum Quantity is '+this.state.max_qty,
			});
		}
		const check= /[^0-9]/gi;
		if(check.test(this.refs.web_edit_qty.value))
		{
			x='* Invalid Quantity';	
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Invalid Quantity',
			});
		}
		if(x==='')
		{
			this.setState({
				err_qty_status:false,
				err_qty_msg:'',
			});
			var data1= {from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),cart_id:this.state.cart_id,quantity:this.state.qty};
		    var data2= JSON.stringify(data1);
		    $.ajax({
	      		method:'POST',
	      		dataType:'json',
	      		url:baseUrl+'update_cart_qty',
	      		data:{req:data2},
	      		success:function(data)
	      		{
	      			if(data.status==="success")
	      			{
	      				this.close();
	      				// this.getCart();
	      				this.applyCoupon_getCart();
	      			}
	      			if(data.status==='error' && data.message==='Token mismatch')
					{
						this.props.tokenCheck();
					}
	      		}.bind(this),
	      		error:function(err)
	      		{
	      		}
      		});
		}
	}
	//function close is used to close all of the modal boxes
	close()
	{
		this.setState({
			openModal:false,
			updateModal:false,
			emptyCartConfirm:false,
			save_local_address_msg_status:false,
			ac_enough_msg_status:false,
			proceedMsg_status: false,
		});
	}
	// function emptyCart is used to empty the cart items and updating the cart and close functions
	emptyCart()
	{
	  var data1= {from:'desktop_web',uid:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
      var data2= JSON.stringify(data1);	
      $.ajax({
      		method:'POST',
      		dataType:'json',
      		url:baseUrl+'Cart_delete',
      		data:{req:data2},
      		success:function(data){
      			if(data.status==="success")
      			{
      				this.getCart();
      				this.close();
      				this.getCartCount();
      				
      			}
      			else
      			{
      				this.close();
      				this.getCartCount();
      			}
      			location.reload();
      			if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
      		error:function(err){
      		}
      });
	}
	//function delete(id) gets the id from the deleteSingleItem(id) and removes the item from the cart.
	delete(id)
	{
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }

	  	var data1= {from:'desktop_web',id:id,uid:uid,token:localStorage.getItem('token')};
      	var data2= JSON.stringify(data1);
       	$.ajax({
      		method:'POST',
      		dataType:'json',
      		url:baseUrl+'singleCart_delete',
      		data:{req:data2},
      		success:function(data)
      		{
      			if(data.status==="success" && data.message==="Item deleted successfully.")
      			{
      				this.getCart();
      				this.getCartCount();
      			}
      			if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
      		}.bind(this),
      		error:function(err)
      		{
      		}
      });
    }
    // function deleteSingleItem(id) changes the status of the item block per 5 seconds to delete, can undo the deletions withing 5 sec or it calls the delete(id) function.
	deleteSingleItem(id)
	{
	  this.setState({
	  		delete_status:true,
	  		delete_status_id:id,
	  });
	  
	  //setTimeout(() => {this.setState({delete_status:false});}, 9000);
	  setTimeout(() => {this.state.delete_status===true ? this.delete(id) : ''}, 2000);
	}

	//applyCoupon_getCart(value,code) function is used to call the cart function with updated state values of coupon price and coupon value. 
	applyCoupon_getCart(value,code)
	{
		this.setState({page_loading:true});
	  if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
	  var data1= {from:'desktop_web',id:uid,token:localStorage.getItem('token'),apply_ac:1,apply_coupon:this.state.coupon_price,apply_coupon_code:this.state.coupon_code,source:source,campaign:campaign,url_id:url_id};
      var data2= JSON.stringify(data1);

      localStorage.setItem('apply_coupon',this.state.coupon_price);
      localStorage.setItem('apply_coupon_code',this.state.coupon_code);
      $.ajax({
      		method:'POST',
      		dataType:'json',
      		url:baseUrl+'cart',
      		data:{req:data2},
      		success:function(data)
      		{
      			console.log(data);
      			localStorage.setItem('apply_coupon',this.state.coupon_price);
      			localStorage.setItem('apply_coupon_code',this.state.coupon_code);
      			this.setState({
      				total:data.total,
      				cartcount:data.cart_count,
      				grandtotal:data.grand_total,
      				items:data.items,
      				ac_discount:data.ac_discount,
      				aqua_cash:data.aqua_cash,
      				used_cash:data.used_cash,
      				used_cash1:data.used_cash1,
      				coupons_amt:data.coupons_amt,
      				coupons_amt1:data.coupons_amt1,
      				grand_total:data.grand_total,
      				applied_coupons:data.applied_coupons,
      				applied_coupons1:data.applied_coupons1,
      				coupons: data.coupons,

      				proceedCheck:data.proceedCheck,
      				proceedMsg:data.proceedMsg,
      				ac_enough_msg:data.ac_enough_msg,
      				loc_msg:data.loc_msg,
      				add_id:data.add_id,


      				state:data.state,
      				zip:data.zip,
      				city:data.city,
      				address: data.address,

      				promodiscount:data.promodiscount,
      				promos:data.promos,
      				applied_promos:data.applied_promos,
				  
					page_loading:false,
					shipping_note: data.shipping_note,
				});
      			localStorage.setItem('address_change_flag',data.address_change);
      			if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
      		error:function(err){
      		}
      });
	}
	//function getCart is used to get the cart values when page loads with empty params of coupons codes and values.
	getCart()
	{
	  this.setState({page_loading:true});	
	  if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
	  var data1= {from:'desktop_web',id:uid,token:localStorage.getItem('token'),apply_ac:1,apply_coupon:0,apply_coupon_code:'',source:source,campaign:campaign,url_id:url_id};
      var data2= JSON.stringify(data1);
      
      localStorage.setItem('apply_coupon',this.state.coupon_price);
      localStorage.setItem('apply_coupon_code',this.state.coupon_code);

      $.ajax({
      		method:'POST',
      		dataType:'json',
      		url:baseUrl+'cart',
      		data:{req:data2},
      		success:function(data)
      		{
      			console.log(data);
      			this.setState({
      				total:data.total,
      				cartcount:data.cart_count,
      				grandtotal:data.grand_total,
      				items:data.items,
      				ac_discount:data.ac_discount,
      				aqua_cash:data.aqua_cash,
      				used_cash:data.used_cash,
      				used_cash1:data.used_cash1,
      				coupons_amt:data.coupons_amt,
      				coupons_amt1:data.coupons_amt1,
      				grand_total:data.grand_total,
      				applied_coupons:data.applied_coupons,
      				applied_coupons1:data.applied_coupons1,
      				coupons: data.coupons,

      				proceedCheck:data.proceedCheck,
      				proceedMsg:data.proceedMsg,
      				ac_enough_msg:data.ac_enough_msg,
      				loc_msg:data.loc_msg,
      				add_id:data.add_id,

      				promodiscount:data.promodiscount,
      				promos:data.promos,
      				applied_promos:data.applied_promos,
					page_loading:false,
					shipping_note:data.shipping_note,
      			});

      			if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
      			localStorage.setItem('address_change_flag',data.address_change);
			}.bind(this),
      		error:function(err){
      		}
      });
	}

	//componentDidMount function is loaded first when page loaded by checking the session and calls the getCart function.
	componentDidMount()
	{
		window.scrollTo(0, 0);
	    localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	    localStorage.removeItem('checkout');
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
		if(!localStorage.token && !localStorage.user_id)
		{
		  	localStorage.setItem('web_mycart','/web/mycart');
		  	browserHistory.push('/web/login');
		}
		else
		{
		 	this.getCart();
		}
		  // localStorage.removeItem('address_change_flag');
		if(screen.width < 800)
		{
			window.location.href='/mycart';
		}
	}
	componentWillMount()
	{
		var that=this;
		setTimeout(function(){
			that.enableBillingDetails();
		},3000);
	}
	enableBillingDetails()
	{
		// this.getCart();
		this.setState({
			billing_status: true,
		});
	}
	changeCoupon()
	{
		this.setState({
			coupon_ref:this.refs.apply_coupon.value,
			coupon_err_status:false,
		});
	}
	submitCoupon()
	{
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
		var data1= {from:'desktop_web',id:uid,token:localStorage.getItem('token'),coupon:this.refs.apply_coupon.value,public_amt:this.state.coupons_amt1,apply_ac:1,source:source,campaign:campaign,url_id:url_id};
      	var data2= JSON.stringify(data1);
      	$.ajax({
      		method:'POST',
      		dataType:'json',
      		url:baseUrl+'applyCoupon',
      		data:{req:data2},
      		success:function(data)
      		{
				if(data.status==="error")
				{
      				this.setState({
      					coupon_err_status: true,
      					coupon_err_msg: data.message,
      				});
      			}
      			if(data.status ==="success")
      			{
      				this.setState({
      					coupon_code:data.code,
      					coupon_price:data.value,
      					coupon_success_msg: data.message,
      					coupon_success_status: true,
      					coupon_success_value:data.value,
      				});
      				this.applyCoupon_getCart(data.value,data.code);
      			}
      			if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
      		}.bind(this),
      		error:function(err){
      		}
      });
	}
	updateMinQty(qty,min_qty,max_qty,cart_id)
	{
		this.setState({
			updateModal:true,
			qty:qty,
			min_qty:min_qty,
			max_qty:max_qty,
			cart_id:cart_id,
		});
	}
	updateMinQtyModal()
	{
		// alert(this.refs.min_qty.value);
		this.setState({
			qty: this.refs.web_edit_qty.value,
			err_qty_status:false,
		});
	}
	//saveAddress_placeOrder() function is called when the coupon is applied and shown location_msg and saving the address,if the address is saved then redirect to checkout page.
	saveAddress_placeOrder()
	{
		if(localStorage.source)
		{
			var source=localStorage.getItem('source');
		}
		else
		{
			source='';
		}
		if(localStorage.campaign)
		{
			var campaign=localStorage.getItem('campaign');
		}
		else
		{
			campaign='';
		}
		if(localStorage.url_id)
		{
			var url_id=localStorage.getItem('url_id');
		}
		else
		{
			url_id='';
		}
		
		if(localStorage.user_id)
	    {
	    	var uid=localStorage.user_id;
	    }
	    else
	    {
	    	uid=0;
	    }
		var data1={from:'desktop_web',uid:uid,token:localStorage.token,mode:2,add_id:this.state.add_id,code:this.state.coupon_code,coupon_amount:this.state.coupon_price,other_amount:'',aqua_cash:this.state.aqua_cash,coupons_amt:this.state.coupons_amt,ac_discount:this.state.ac_discount,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,source:source,campaign:campaign,url_id:url_id,aqua_cash:this.state.aqua_cash};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'cartCalculations',
			success:function(data)
			{
				this.applyCoupon_getCart();
				if(data.status==="success")
				{
					browserHistory.push('/checkout');
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{
			}
		});
	}

	placeOrder()
	{
			this.setState({
				pay_clicked:true,
			});
			if(this.state.proceedCheck === 0 && this.state.proceedMsg!=="")
			{
				this.setState({
					proceedMsg_status:true,
					pay_clicked:false,
				});
			}
			else if(this.state.proceedCheck === 0 && this.state.ac_enough_msg !=="")
			{
				this.setState({
					ac_enough_msg_status:true,
					pay_clicked:false,
				});
			}
			else if(this.state.proceedCheck=== 0 && this.state.loc_msg !=="")
			{
				this.setState({
					save_local_address_msg_status:true,
					pay_clicked:false,
				});
			}
			else
			{
				this.setState({
					checkout_page_loading:true,
				});
				if(localStorage.source)
				{
					var source=localStorage.getItem('source');
				}
				else
				{
					source='';
				}
				if(localStorage.campaign)
				{
					var campaign=localStorage.getItem('campaign');
				}
				else
				{
					campaign='';
				}
				if(localStorage.url_id)
				{
					var url_id=localStorage.getItem('url_id');
				}
				else
				{
					url_id='';
				}
				
				if(localStorage.user_id)
			    {
			    	var uid=localStorage.user_id;
			    }
			    else
			    {
			    	uid=0;
			    }
				var data1={from:'desktop_web',uid:uid,token:localStorage.token,mode:2,add_id:this.state.add_id,code:this.state.coupon_code,coupon_amount:this.state.coupon_price,other_amount:'',aqua_cash:this.state.used_cash1,coupons_amt:this.state.coupons_amt,ac_discount:this.state.ac_discount,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,source:source,campaign:campaign,url_id:url_id,aqua_cash:this.state.aqua_cash};
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'POST',
					dataType:'json',
					data:{req:data2},
					url:baseUrl+'cartCalculations',
					success:function(data)
					{
						this.applyCoupon_getCart();
						if(data.status==="success")
						{
							browserHistory.push('/web/checkout');
						}
						if(data.status==='error' && data.message==='Token mismatch')
						{
							this.props.tokenCheck();
						}
					}.bind(this),
					error:function(err)
					{
					}
				});
			}		
	}
	removeCoupon()
	{
		this.setState({
			coupon_success_status:false,
			coupon_code:0,
			coupon_price:0,
		});
		localStorage.setItem('apply_coupon',0);
      	localStorage.setItem('apply_coupon_code',0);
		this.getCart();
	}
	render(){
		document.title="My Cart | AquaDeals";
		var cart_items=this.state.items.map(function(item,index){
			return(
				<div>
					{this.state.delete_status && this.state.delete_status_id===item.id ? 
					 		<div className="row">
						 		<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{padding:'10px',color:'#666'}}>
						 			<span>Deleted</span>
						 			<span style={{float:'right',cursor:'pointer'}} onClick={()=>{this.setState({delete_status:false})}}>UNDO</span>
						 		</div>
					 		</div>
					 		 : 
						<div className="row cart_ItemsList">
						  <div className="row">
							 <div className='container'>	
								<div className="col-sm-2 col-md-2 col-lg-2 webcart_centerimg">     
								     <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}>
										{item.type === 0 ? <img src={baseAssets+'icons/'+item.img} alt=" " /> : <img src={baseAssets+'images/product_imgs/thumbnails/'+item.img}  alt=" "  />}
								     </Link>
								</div> 
								<div className="cartdesc_Blk">
									<div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 cart_title_blk">
									    <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}>
									  	{item.pro_name !=="" ? <h3 className="cartitem_Title">{item.pro_name}</h3> : <h3 className="cartitem_Title">&nbsp;</h3>}
									    {item.brand ? <h4 className="cartitem_Brand">{item.brand}</h4>:<h4>&nbsp;</h4>} 
									   </Link>
									</div>	
									<div className="col-lg-2 col-md-2 col-sm-2">
                                        {item.mrp ? <h4 className="cartitem_Mrp">&#8377; {item.mrp}</h4>:<h4>&nbsp;</h4>} 
									</div>
									<div className="col-xs-3 col-sm-3 col-md-3  col-lg-3 text-center">
										{item.min_qty !== "" ? <p onClick={()=>{this.updateMinQty(item.qty,item.min_qty,item.max_qty,item.id)}} className="webQty_Edit"><span>{item.qty}</span></p> :<p>&nbsp;</p>}
									</div>
									<div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 text-center" style={{paddingLeft:'0px',paddingRight:'0px'}}>   
									   <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}>
										 {item.amount !== "" ? <p className="cartitem_amount"><span>&#8377; </span><span>{item.amount}</span></p> :<p>&nbsp;</p>}
									   </Link>
									</div>
									<div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
									   <button  onClick={()=>{item.type === 1 ? this.deleteSingleItem(item.id) : this.deleteSingleItem(item.id)}} ariaLabel="Close" className="close cartitem_removebtn" type="button">
										<p ariaHidden="true">×</p>
									   </button>
							        </div>
								</div>
							</div>
						</div>
					  </div>	
					}
				</div>
			);
		}.bind(this));
		var cart_coupons='';
		cart_coupons=<div className="row" style={{paddingTop:'20px',paddingBottom:'20px'}}>
							<div className="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
							<div className="col-sm-4 col-xs-4 col-md-4 col-lg-4 cart_coupon_blk">
								<i className="cart_left_img">
									<img src={baseAssets+'icons/web_icons/coupon_left.png'} alt=" "/>
								</i>
								<input type="text" ref="apply_coupon" maxLength={15} placeholder="Enter coupon code" onChange={()=>{this.changeCoupon()}} />
							</div>
							<div className="col-sm-2 col-xs-2 col-lg-2">
								<div className="cart_submit">
									<button className="cart_submitbtn" onClick={()=>{this.submitCoupon()}}>Apply</button>
								</div>
							</div>
							<div className="col-sm-12 col-xs-12 col-lg-12"></div>
							<div className="col-sm-4 col-sm-offset-1 col-xs-4 col-xs-offset-1 err_coupon">
								<span>{this.state.coupon_err_status ? this.state.coupon_err_msg : ''}</span>
							</div>
					 </div>; 
		
		var coupon_map = this.state.coupons.map(function(coupon,index){
			return(
				<span key={index} style={{display:'block'}}>{coupon.coupon_code} (&#8377;{coupon.value} )</span>
				);
		});
		const couponsList = (
				<Popover id="popover-positioned-top1">
					{coupon_map}
				</Popover>
		);
		var coupon_info=<OverlayTrigger trigger="focus" placement="top" overlay={couponsList}>
							<Button className="cartCoupon_info_img"><img src={baseAssets+'icons/web_icons/coupon_info.png'} alt=" " /></Button>
						</OverlayTrigger>;
		
		var promos_map=this.state.promos.map(function(promo,index){
			return(
				<span key={index} style={{display:'block'}}>{promo.promo_code} ( &#8377; {promo.promo_value} )</span>
				);
		});
		const promosList=<Popover id="popover-positioned-top2">
							{promos_map}
						 </Popover>;

		var promo_info='';
		promo_info=<OverlayTrigger trigger="focus" placement="top" overlay={promosList}>
						<Button className="cartCoupon_info_img"><img src={baseAssets+'icons/web_icons/coupon_info.png'} alt=" " /></Button>
					</OverlayTrigger>;
		var coupon_success='';


		if(this.state.coupon_success_status)
		{
			coupon_success=<div className="cartCoupon_Success cart_cpn_success">
								<button onClick={()=> {this.removeCoupon()}} ariaLabel="Close" className="coupon_close" type="button">
									<i><img src={baseAssets+'icons/web_icons/cancel_coupon.png'} alt="" width="20px" /></i>
								</button>
								<h5>Coupon discount:(-) &#8377; {this.state.coupon_success_value}</h5>	
								<p>{this.state.coupon_success_msg}</p>
						   </div>
		}
		return(
				<div className="web_Deals Web_CartPage ">
			        <WebHeaderInner cart_updated_count={this.state.cartcount} />
			        {/*<WebHeaderInner />*/}
			        <div className="clr">&nbsp;</div>
			        <div className="clr">&nbsp;</div>
			        <div className="clr">&nbsp;</div>
			        <div className="clr">&nbsp;</div>
				    <div className="clr">&nbsp;</div>
			        <div className="clr">&nbsp;</div>
				    <div className='container'>
						<Breadcrumb className="webcart_breadcrumb">
					       <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
					       <Breadcrumb.Item active>My Cart</Breadcrumb.Item>
				        </Breadcrumb>
					</div>
					{this.state.page_loading ? 
					 <div className="col-lg-12 col-md-12 col-sm-12 Dels_cntnt">	
					    <div className="web_cart_loading">
			       	       <img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  />
				        </div>
					 </div>
					 :
					<div>  
				      {this.state.cartcount !== 0 ?
					 	 <section className="container">
						    <div className="row">
						          <div className="col-lg-12 col-md-12 col-sm-12 Dels_cntnt">
								    <section className="container-fluid">
           
            {this.state.checkout_page_loading ? '' :
              <section id="cart-process">
                <div className="progressbar-wrapper"  style={{background:'unset!important'}}>
                  <ul className="progressbar">
                    <li className="active">
                      <div>Cart</div>
                      <div><Icon
                        name='check'
                        font='Entypo'
                        color='#fff'
                        size={14}
                      // style={{}}
                      />
                      </div>
                    </li>
                    <li>Checkout</li>
                    <li>Payment</li>
                  </ul>
                </div>
              </section>
            }								    
									 	<div className="row Mycart_Block" style={{marginTop:'15px'}}>									 	
									 		<div className="container-fluid">
												<a className="pull-right delete_item" onClick={()=>{this.emptyCartConfirm()}}><img src={baseAssets+'icons/web_icons/del_bin3.png'} width="16px" alt="Home" />Delete all</a>
											</div>
											<hr />
										</div>
									 	<div className="row cart_head_blk">
									 		<div className="col-lg-5 col-md-5 col-sm-5 col-xs-5" style={{paddingRight:'0'}}>
									 		    <span className="add_head">Added Item</span> 
									 		</div>
									 		<div className="col-lg-2 col-md-2 col-sm-2">
                                                <span className="add_mrp">MRP</span>
									 		</div>
									 		<div className="col-lg-4 col-md-4 col-sm-4 col-xs-4" style={{paddingLeft:'0'}}>
									 		   <div className="col-lg-6 col-md-6 col-sm-6">
 												<span className="qun_head">Quantity</span>						
									 		   </div>
									 		   <div className="col-lg-6 col-md-6 col-sm-6 text-center">
                                                <span className="price_head">Price</span>
									 		   </div> 
										    </div>
										</div>
										<div className="cart_itemsblk">
											{cart_items}
										</div>
									</section>
									<section className="container-fluid" style={{marginTop:'20px'}}>
                                       <div className="row">
                                     <div className="col-md-6 col-lg-6 col-sm-6">
                                         {this.state.coupon_success_status ? coupon_success : cart_coupons }
                                          <div className="col-md-6 col-lg-6">&nbsp;</div>
                                      </div>
                                           <div className="col-md-6 col-lg-6 col-sm-6" style={{paddingLeft:'0'}}>
	                                           {/* <h4 style={{paddingLeft:'14%'}}>Total Price &nbsp;&nbsp; &#8377;{this.state.total}</h4>
	                                            
	                                            <h4 style={{paddingLeft:'14%'}}>Total Price &nbsp;&nbsp; &#8377;{this.state.total}</h4>
	                                            <h4 style={{paddingLeft:'14%'}}>Total Price &nbsp;&nbsp; &#8377;{this.state.total}</h4> */}
	                                          {this.state.billing_status ?
												<table className="table cartTable">
													<tr className="cartTr_Total">
														<td>Total Price</td>
														<td>&#8377; {this.state.total}</td>
													</tr>
													{this.state.used_cash ? 
													<tr className="cartTr">
														<td>Aquacash Discount</td>
														<td>(-) &#8377; {this.state.used_cash}</td>
													</tr> : ''}

													{this.state.coupons_amt1 ? 
											 	<tr className="cartTr cartTrEnd">{this.state.coupons.length ===1 ? <td>Applied Coupon <span className="appliedCoupon_Msg">: {this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''}</span></td> : <td>Coupons applied on your purchase {coupon_info}</td>}
												<td>(-) &#8377; {this.state.coupons_amt}</td></tr> : '' }
													{parseInt(this.state.promodiscount,10) > 0 ? 
													<tr>
														<td>Promos Discount {this.state.promos.length=== 1 ? <span className="appliedCoupon_Msg">: {this.state.promos[0].promo_code}</span> : promo_info } </td>
														<td>(-) &#8377; {this.state.promodiscount}</td>
													</tr>
											 	: ''}
											 	   <tr className="cartTr_Grandtotal">
														<td>Grand Total</td>
														<td>&#8377; {this.state.grand_total}</td>
													</tr>
													<tr>
													<td colSpan={2}>{parseHtml(this.state.shipping_note)}</td>
													</tr>																																							
												</table> : <div className="webPrice_Loading"><img src={baseAssets+'images/loading_more.gif'} alt="Loading"  /></div>}
	                                       </div> 
                                       </div>
									</section>
									<section className="container-fluid">  
									   <div className="webBotm_Btns row" style={{marginTop:'4%'}}>
											<ul>	
												<li className="col-lg-4 col-md-4 col-xs-4 col-sm-5" style={{cursor:'pointer'}}><Link to={'/web/home'} title="">CONTINUE SHOPPING</Link></li>
												{/* <li className="col-md-6 col-xs-6 col-sm-6" style={{cursor: 'pointer'}}><a onClick={()=>{this.setState({openModal:true});}}>Place Order</a></li> */}
												<li className="col-lg-4 col-md-4 col-xs-4 col-sm-2">&nbsp;</li> 
												<li className="col-lg-4 col-md-4 col-xs-4 col-sm-5 text-right" style={{cursor: 'pointer'}}>{this.state.pay_clicked ? <Link className="disabled">Processing...</Link> : <a onClick={()=>{this.placeOrder()}} >PROCEED TO CHECKOUT</a>}</li>
											</ul>
									   </div>
                                   </section>   
								</div>
							</div>
						</section>
					: 
						<section className="container">
							<div className="row">
								<div className="col-lg-12 col-md-12 EmptyDels_cntnt">
									<div>
										<div className="webCart_Empty">
											<i><img src={baseAssets+'icons/web_icons/empty_cartbg.png'} alt="..." /></i>
											<h3>Your Cart is Empty</h3>
											<Link to={"/web/home"} className="cart_ShopBtn">SHOP NOW</Link>
										</div>
									</div>
								</div>
							</div>
						</section>
					}
					</div>
				   
				 }	
					<Modal className=""  show={this.state.openModal} onHide={this.close}  >
						<Modal.Header closeButton>
					   		<Modal.Title style={{fontSize: '16px',color:'#333'}}>AquaDeals</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<h4 style={{fontSize:'14px', color:'#666'}}>You need to install Android mobile app to place this order.</h4>
						</Modal.Body>
						<Modal.Footer className="Modal_Footer">
							<Button style={{background: '#fff none repeat scroll 0 0',color:'#ff742a'}} onClick={this.close}>Close</Button>
							<a href="https://play.google.com/store/apps/details?id=com.aquadeals.user&hl=en" target="_blank" title=""><Button style={{background: '#ff742a none repeat scroll 0 0',color: '#fff'}}>OK</Button></a>
						</Modal.Footer>
					</Modal>

					<Modal className="webEdit_Qty_Modal"  show={this.state.updateModal} onHide={this.close}  >
						<Modal.Body>
							<h4><input ref="web_edit_qty" type="text" value={this.state.qty} placeholder="Enter Quantity" onChange={()=>{this.updateMinQtyModal()}} /></h4>
							{this.state.err_qty_status ? <p className="webErr_Qty">{this.state.err_qty_msg}</p> : ''}
						</Modal.Body>
						<Modal.Footer className="web_EditQty_Footer">
							<Button className="web_Edit_Qty_cls_Btn" onClick={this.close}>CANCEL</Button>
							<a><Button className="web_edit_qty_Update_Btn" onClick={()=>{this.updateQuantity()}}>UPDATE</Button></a>
						</Modal.Footer>
					</Modal>

					<Modal className="" show={this.state.emptyCartConfirm} onHide={this.close}  >
						<Modal.Body>
				  			<h4>Do you want to remove all items? </h4>
				  		</Modal.Body>
				  		<Modal.Footer className="mob_Cart_Confirm">
				  			<Button className="" onClick={this.close}>NO</Button>
				  			<a><Button className="" onClick={()=>{this.emptyCart()}}>YES</Button></a>
				  		</Modal.Footer>
					</Modal>
					<WebFooter /> 
				</div>
			);
		}
}

function mapStateToProps(state){
  return {
  };
}

export default connect(mapStateToProps,actions)(Web_MyCart);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Cart/Web_MyCart.js
 **/